import React from 'react';
import { useMatch } from '../context/MatchContext';
import { calculatePoints, getPointsDisplay } from '../utils/scoring';

function OutcomePanel({ onConfirm, onCancel }) {
  const { state, setActionField } = useMatch();
  const { currentAction } = state;

  const pts = calculatePoints(
    currentAction.technique,
    currentAction.target,
    currentAction.outcome,
    currentAction.technicalBonus
  );
  const ptDisplay = getPointsDisplay(pts);

  const isClash = currentAction.technique === 'Clsh';

  // Clash: parata — non può fare punto, bersaglio non richiesto
  // Altri:  se outcome = 'punto' serve il bersaglio
  const outcomeOk = isClash
    ? true
    : !!(currentAction.outcome) && (
        currentAction.outcome === 'tocco' ||
        currentAction.outcome === 'miss'  ||
        (currentAction.outcome === 'punto' && !!currentAction.target)
      );

  const isValid = !!(
    currentAction.athlete &&
    currentAction.actionType &&
    currentAction.technique &&
    outcomeOk
  );

  const handleConfirm = () => {
    if (!isValid) return;
    onConfirm({ ...currentAction, points: pts });
  };

  return (
    <div className="panel">
      <div className="panel-header">Esito</div>
      <div className="panel-body">

        {/* Bersaglio — nascosto per Clash (parata senza bersaglio) */}
        {!isClash && (
          <div className="panel-section">
            <span className="panel-label">Bersaglio</span>
            <div className="toggle-group" style={{ flexDirection: 'column' }}>
              {[
                { value: 'corpo', label: 'Corpo' },
                { value: 'testa', label: 'Testa' },
              ].map(opt => (
                <button
                  key={opt.value}
                  className={`toggle-btn${currentAction.target === opt.value ? ' selected' : ''}`}
                  style={{ width: '100%' }}
                  onClick={() => setActionField('target', currentAction.target === opt.value ? null : opt.value)}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Esito */}
        <div className="panel-section">
          <span className="panel-label">Esito</span>
          {isClash && (
            <div style={{ fontSize: 11, color: 'var(--color-orange)', marginBottom: 4 }}>
              Parata — non assegna punti
            </div>
          )}
          <div className="toggle-group" style={{ flexDirection: 'column' }}>
            {[
              { value: 'punto', label: 'Punto' },
              { value: 'tocco', label: 'Tocco ~' },
              { value: 'miss',  label: 'Miss X' },
            ].map(opt => {
              const disabled = isClash && opt.value === 'punto';
              return (
                <button
                  key={opt.value}
                  className={`toggle-btn${currentAction.outcome === opt.value ? ' selected' : ''}`}
                  style={{ width: '100%', opacity: disabled ? 0.3 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
                  disabled={disabled}
                  onClick={() => !disabled && setActionField('outcome', currentAction.outcome === opt.value ? null : opt.value)}
                >
                  {opt.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Bonus rotazione */}
        <div className="panel-section">
          <label className="checkbox-row">
            <input
              type="checkbox"
              checked={!!currentAction.technicalBonus}
              onChange={e => setActionField('technicalBonus', e.target.checked)}
            />
            <span>Rotazione (+pt)</span>
          </label>
        </div>

        {/* Display punti */}
        <div className="points-display">
          <div
            className={`points-number${pts === 0 ? ' zero' : ''}`}
            style={{ color: ptDisplay.color }}
          >
            {pts}
          </div>
          <div className="points-label">
            {pts === 0 ? 'punti' : pts === 1 ? 'punto' : 'punti'}
          </div>
        </div>

        <div className="panel-section">
          {!isValid && (
            <div style={{ fontSize: 10, color: 'var(--color-text-dim)', textAlign: 'center', marginBottom: 4 }}>
              {!currentAction.athlete && <div>Seleziona atleta</div>}
              {!currentAction.actionType && <div>Seleziona tipo azione</div>}
              {!currentAction.technique && <div>Seleziona tecnica</div>}
              {!currentAction.outcome && <div>Seleziona esito</div>}
              {!isClash && currentAction.outcome === 'punto' && !currentAction.target && <div>Seleziona bersaglio</div>}
              {isClash && currentAction.outcome === 'punto' && <div>Clash non può fare punto</div>}
            </div>
          )}
          <button
            className="confirm-btn"
            disabled={!isValid}
            onClick={handleConfirm}
          >
            Conferma Azione
          </button>
          <button className="cancel-btn" style={{ marginTop: 6 }} onClick={onCancel}>
            Annulla
          </button>
        </div>

      </div>
    </div>
  );
}

export default OutcomePanel;
